import * as React from "react";
import "../../../styles/component/rich-text-view.scss";

export const RichTextView = (props: {
    content: string;
    diffMode?: boolean;
}) => {
    return <div dangerouslySetInnerHTML={{ __html: props.content }} className={"rich-text-view" + (!!props.diffMode ? " text-diff" : "")} />;
};